import React from "react";
import { useTranslation } from "react-i18next";

function YandexMapSection() {

    var { t } = useTranslation();

    var locationLatitude = 51.146744;
    var locationLongitude = 71.371706;

    // Construct direct Yandex map URL
    var mapUrl =
        "https://yandex.com/map-widget/v1/?ll=" +
        locationLongitude +
        "%2C" +
        locationLatitude +
        "&z=16";

    return (
        <section
            className="uk-section uk-section-default"
            style={{
                position: "relative",
                padding: "0",
                height: "500px",
                overflow: "hidden"
            }}
        >
            {/* Full-screen Yandex map */}
            <iframe
                title="Yandex Map"
                src="https://yandex.com/map-widget/v1/?um=constructor%3A213264ec8d787caf2f00379e553efededeece715c1b58b02bf5f99d5622eca55&source=constructor"
                width="100%"
                height="500"
                frameBorder="0"
                style={{ border: "none", zIndex: 0, position: "absolute", top: 0, left: 0 }}
                allowFullScreen
            ></iframe>

            {/* Overlay container */}
            <div
                className="uk-container"
                style={{
                    position: "relative",
                    zIndex: "100",
                    height: "100%"
                }}
            >
                <div
                    className="uk-position-top-left uk-position-relative uk-width-1-1 uk-width-auto@s uk-flex uk-flex-center uk-flex-top@s"
                    style={{
                        paddingTop: "40px",
                        paddingLeft: "20px",
                        maxWidth: "580px"
                    }}
                >
                    <div className="uk-card uk-card-default uk-card-hover uk-border-rounded uk-box-shadow-small">
                        <div className="uk-card-body">
                            <h3 className="uk-card-title">
                                {t("infopages.landing.contact1")}
                            </h3>
                            <ul className="uk-list uk-list-divider">
                                <li>
                                    <strong>{t("infopages.landing.address_h")}</strong><br />
                                    {t("infopages.landing.address_p")}
                                </li>
                                <li>
                                    <strong>
                                        {t("infopages.landing.email_h")}    
                                    </strong><br />
                                    <a
                                        href="mailto:international@jai.com.kz"
                                        style={{ color: "#1e87f0", textDecoration: "none" }}
                                    >
                                        international@jai.com.kz
                                    </a>
                                </li>
                                <li>
                                    <strong>
                                        {t("infopages.landing.phone_h")}    
                                    </strong><br />
                                    <a
                                        href="tel:+77750912804"
                                        style={{ color: "#1e87f0", textDecoration: "none" }}
                                    >
                                        +7 775 091 2804
                                    </a>
                                </li>
                            </ul>
                            <a
                                href="/apply-visa"
                                className="uk-button uk-button-jai"
                                style={{ marginTop: "10px" }}
                            >
                                {t("infopages.landing.cta2")}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default YandexMapSection;
